import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds, FirstAds, MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";

const TITLE = "Calculateur de moyenne GPA 5.0";
const DESCRIPTION =
  "Calculateur de moyenne GPA 5.0 pour suivre vos notes, moyennes et conversions scolaires avec precision. Outil utile pour planifier vos objectifs et mieux piloter votre progression academique.";
const KEYWORDS =
  "de moyenne gpa 5.0, calculatrice de moyenne gpa 5.0, calcul en ligne, etudes, notes, GPA, resultat rapide";
const OG_URL = "https://do-calculate.com/calculator/fr/gpa5/";

function GPA5() {
  const [grades, setGrades] = useState([]);
  const [gpaResult, setGpaResult] = useState(null);

  const addGrade = () => {
    setGrades([...grades, { grade: "", credit: "" }]);
  };

  const removeGrade = (index) => {
    const newGrades = grades.filter((_, i) => i !== index);
    setGrades(newGrades);
  };

  const updateGrade = (index, field, value) => {
    const newGrades = [...grades];
    newGrades[index][field] = value;
    setGrades(newGrades);
  };

  const calculateGPA = () => {
    let totalGradePoints = 0;
    let totalCredits = 0;

    grades.forEach((g) => {
      const grade = parseFloat(g.grade);
      const credit = parseFloat(g.credit);
      if (!isNaN(grade) && !isNaN(credit)) {
        totalGradePoints += grade * credit;
        totalCredits += credit;
      }
    });

    if (totalCredits > 0) {
      const gpa = totalGradePoints / totalCredits;
      setGpaResult(gpa.toFixed(2));
    }
  };

  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  La moyenne GPA (Grade Point Average) sur une échelle de 5.0 est un système de notation couramment utilisé dans les établissements d'enseignement supérieur. Utilisez cette calculatrice pour déterminer votre GPA moyen en entrant vos notes de cours et les crédits associés.
                </p>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-9 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>Calculateur de GPA 5.0</h2>
                </div>
                <div className="p-3">
                  {grades.map((grade, index) => (
                    <div key={index} className="row mb-3">
                      <div className="col-md-5">
                        <input
                          type="number"
                          placeholder="Note (0-5)"
                          value={grade.grade}
                          onChange={(e) =>
                            updateGrade(index, "grade", e.target.value)
                          }
                          className="form-control"
                          max="5"
                          step="0.1"
                        />
                      </div>
                      <div className="col-md-5">
                        <input
                          type="number"
                          placeholder="Crédits"
                          value={grade.credit}
                          onChange={(e) =>
                            updateGrade(index, "credit", e.target.value)
                          }
                          className="form-control"
                        />
                      </div>
                      <div className="col-md-2">
                        <button
                          className="btn btn-danger"
                          onClick={() => removeGrade(index)}
                        >
                          Supprimer
                        </button>
                      </div>
                    </div>
                  ))}
                  <button
                    className="btn btn-primary"
                    onClick={addGrade}
                    style={{ marginRight: "10px" }}
                  >
                    Ajouter un cours
                  </button>
                  <button
                    className="btn btn-success"
                    onClick={calculateGPA}
                  >
                    Calculer le GPA
                  </button>
                </div>
                {gpaResult && (
                  <div className="p-3 mb-2 bg-success text-white">
                    <h3>Votre GPA : {gpaResult}</h3>
                  </div>
                )}
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList />
          <br />
        </div>
      </div>
    </div>
  );
}

export default GPA5;